// 最外层管理路由
import switchLayout from '@/layout/index.vue'
import switchHome from '@/views/switch/home.vue'
import switchStationSetting from '@/views/switch/stationsetting.vue'

const router = {
  path: '/layout',
  name: 'switchLayout',
  component: switchLayout,
  redirect: '/home',
  children: [
    {
      path: '/switch/home',
      name: 'switch_home',
      meta: {
        showTab: true,
        name: 'switch_home mulshow',
        title: '蓝蜘蛛 开关控制'
      },
      component: switchHome
    },
    {
      path: '/switch/stationsetting',
      name: 'switch_station_setting',
      meta: {
        showTab: true,
        name: 'switch_station_setting mulshow',
        title: '蓝蜘蛛 电站设置'
      },
      component: switchStationSetting
    },
  ]
}

export default router

